import { format, set, subHours } from 'date-fns';
import { IntentTypes } from 'evergreen-ui';

export type StatusDataType = {
  text: string,
  intent: CustomIntentTypes,
  time: string,
}
export const initialStatusData: StatusDataType = {
  text: 'Неизвестен',
  intent: 'none',
  time: '',
};

export type Palette = {
  MAIN: string
  ADDITIONAL_1: string
  ADDITIONAL_2: string
}

/**
 * @param date строка даты, которая подходит для new Date()
 */
export const getTimeFormatForStatus = (date?: string) => {
  return date ? `${format(new Date(date), 'dd.MM.yyyy HH:mm')} UTC` : '';
};

export const getSuccessColors = (opacity = 1): Palette => ({
  MAIN: `rgba(34, 197, 94, ${opacity})`,
  ADDITIONAL_1: `rgba(22, 163, 74, ${opacity})`,
  ADDITIONAL_2: `rgba(21, 128, 60, ${opacity})`,
});

export const getWarningColors = (opacity = 1): Palette => ({
  MAIN: `rgba(251, 190, 36, ${opacity})`,
  ADDITIONAL_1: `rgba(245, 159, 11, ${opacity})`,
  ADDITIONAL_2: `rgba(217, 119, 6, ${opacity})`,
});

export const getDangerColors = (opacity = 1): Palette => ({
  MAIN: `rgba(239, 68, 68, ${opacity})`,
  ADDITIONAL_1: `rgba(220, 38, 38, ${opacity})`,
  ADDITIONAL_2: `rgba(185, 28, 28, ${opacity})`,
});

export const getNoneColors = (opacity = 1): Palette => ({
  MAIN: `rgba(128,128,128,${opacity})`,
  ADDITIONAL_1: `rgba(156, 163, 175, ${opacity})`,
  ADDITIONAL_2: `rgba(107, 114, 128, ${opacity})`,
});

export const CustomIntent = Object.freeze({
  success: getSuccessColors().MAIN,
  warning: getWarningColors().MAIN,
  danger: getDangerColors().MAIN,
  none: getNoneColors().MAIN,
});
export type CustomIntentTypes = keyof typeof CustomIntent

/** Стартовое время и конечное для подстановки в рест datasource-programs/report статусы ReceivedData */
export const timeFormat = "yyyy-MM-dd'T'HH:mm:ss";
const date = new Date();
export const startDate = format(subHours(set(date, {
  hours: date
    .getUTCHours(),
  minutes: date
    .getUTCMinutes(),
  seconds: date
    .getUTCSeconds(),
}), 24), timeFormat);

export const endDate = format(set(date, {
  hours: date
    .getUTCHours(),
  minutes: date
    .getUTCMinutes(),
  seconds: date
    .getUTCSeconds(),
}), timeFormat);
